import Vue from 'vue'
import store from '@packages/store'

export default {

    async find(id) {
        return await Vue.api.advertisers.find(id)
    },

    async establishments({establishmentId, search}) {
        const establishments = await Vue.api.advertisers.establishments({establishmentId, search})

        store.commit('ADVERTISERS_SET_ESTABLISHMENTS', establishments)

        return establishments
    },

    async boundEstablishments(id) {
        const establishments = await Vue.api.advertisers.boundEstablishments(id)

        store.commit('ADVERTISERS_SET_BOUND_ESTABLISHMENTS', establishments)

        return establishments
    },

}
